import styled from '@emotion/styled';

export const sizes = {
  tiny: ['16px', '16px', '6px', '3px'],
  small: ['24px', '24px', '8px', '6px'],
  medium: ['32px', '32px', '12px', '6px'],
  large: ['64px', '64px', '18px', '8px'],
};

export const OnlineIndicator = styled.div`
  width: ${({ size }) => sizes[size][3]};
  height: ${({ size }) => sizes[size][3]};
  background: ${({ status }) => (status === 'online' ? '#43af11' : '#e30b5c')};
  border-radius: 50%;

  //animation: fade 1.5s infinite;
  animation: ${({ pulse = false }) => pulse && 'fade 1.5s infinite'};

  @keyframes fade {
    0%,
    100% {
      opacity: 0.1;
    }
    50% {
      opacity: 1;
    }
  }
`;
